import { render, staticRenderFns } from "./invalidTable.vue?vue&type=template&id=281b5944&scoped=true"
import script from "./invalidTable.vue?vue&type=script&lang=js"
export * from "./invalidTable.vue?vue&type=script&lang=js"
import style0 from "./invalidTable.vue?vue&type=style&index=0&id=281b5944&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b5944",
  null
  
)

export default component.exports